<mat-drawer-container hasBackdrop>
    <mat-drawer autoFocus="false" #drawer mode="over" position="end" (closed)="close()">
        <app-right-sidebar-container [title]="(isEditing ? 'Update' : 'Create') + ' Consultant'"
            [footerSubmitCustomLabel]="isEditing ? 'Update' : 'Create'" (cancel)="close()" (submit)="onSubmit()"
            [disableSubmit]="form.invalid || isLoading">
            <form [formGroup]="form" class="consultant-content">
                <div class="custom-form-field">
                    <label for="email">Email address<span class="required">*</span></label>
                    <mat-form-field appearance="outline" class="custom-field">
                        <input formControlName="email" matInput name="email" />
                        @if (form.controls['email'].errors?.['required']) {
                        <mat-error>
                            Enter email address
                        </mat-error>
                        }
                        @if (form.controls['email'].errors?.['email']) {
                        <mat-error>
                            Enter valid email address
                        </mat-error>
                        }
                        @if (form.controls['email'].errors?.['entityExists']) {
                        <mat-error>
                            User already exists with this email
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="custom-form-field">
                    <label for="firstName">First Name<span class="required">*</span></label>
                    <mat-form-field appearance="outline" class="custom-field">
                        <input formControlName="firstName" matInput name="firstName" />
                        @if (form.controls['firstName'].errors?.['required']) {
                        <mat-error>
                            Enter First Name
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="custom-form-field">
                    <label for="lastName">Last Name<span class="required">*</span></label>
                    <mat-form-field appearance="outline" class="custom-field">
                        <input formControlName="lastName" matInput name="lastName" />
                        @if (form.controls['lastName'].errors?.['required']) {
                        <mat-error>
                            Enter Last Name
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="custom-form-field">
                    <label for="phoneNumber">Phone Number<span class="required">*</span></label>
                    <mat-form-field appearance="outline" class="custom-field">
                        <input formControlName="phoneNumber" matInput name="phoneNumber" type="tel" maxlength="10"
                            minlength="10" [appPhoneInput]="true" />
                        @if (form.controls['phoneNumber'].errors?.['required']) {
                        <mat-error>
                            Enter Phone Number
                        </mat-error>
                        }
                        @if (form.controls['phoneNumber'].errors?.['invalidPhone']) {
                        <mat-error>Phone number must be exactly 10 digits</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="custom-form-field">
                    <label for="providerOrgs">Assigned Provider Organizations</label>
                    <mat-form-field appearance="outline" class="custom-field">
                        <mat-select multiple [value]="selectedProviderOrgIds"
                            (selectionChange)="onProviderOrgSelectionChange($event.value)"
                            placeholder="Select organizations">
                            @for (org of getOrganizationsForDisplay(); track org.id) {
                            <mat-option [value]="org.id" [class]="'provider-org-option level-' + org.level">
                                {{ org.displayName }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </form>
        </app-right-sidebar-container>
    </mat-drawer>
    <mat-drawer-content>
        <div class="pcs-container">
            <div class="pcs-header">
                <h3 class="pcs-title">{{organization?.name || '-'}}</h3>
            </div>
            <br />

            <div class="card-body">
                <app-row-details-data [data]="descriptionRowData"></app-row-details-data>

                <br />
                <div>
                    <mat-tab-group class="consultant-tabs" mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="Users">
                            <ng-template matTabContent>
                                <div class="pcs-container">
                                    <div class="pcs-header">
                                        <h3 class="pcs-title">Users</h3>
                                        @if (isAdmin()) {
                                        <div class="card-actions">
                                            <button (click)="openConsultantSidebar()" mat-flat-button color="primary"
                                                type="button"><mat-icon>add</mat-icon> Create</button>
                                        </div>
                                        }
                                    </div>
                                    <app-search-sort [searchControl]="searchControl" [sortForm]="sortForm"
                                        [sortOptions]="sortOptions" (apply)="setSortField()"
                                        (close)="resetSortField()"></app-search-sort>
                                    <div class="pro-card column">

                                        <app-ag-grid-wrapper [data]="rowData" [columns]="columnDefs"
                                            (ready)="onGridReady($event)" />
                                        <mat-paginator #paginator
                                            [selectConfig]="{ panelClass: 'mat-paginator-select-options' }"
                                            [length]="this.totalCount" [pageIndex]="this.currentPage"
                                            [pageSize]="this.pageSize" [pageSizeOptions]="pageSettings.pageSizeOptions"
                                            (page)="handlePageEvent($event)" aria-label="Select page">
                                        </mat-paginator>
                                    </div>
                                </div>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>
    </mat-drawer-content>
</mat-drawer-container>